import React from "react";
import {RecentlyPlayedComponent} from "../../../../../components/recently-played/recently-played.component";
import {ApiListBaseModel} from "../api-list-base.model";


export class RecentlyPlayedListModel extends ApiListBaseModel {

    protected _shouldBeDisplayed(): boolean {
        if(!this.services.user.isAuthorized || this.services.games.recentlyPlayedGames.isInitialized) {
            return super._shouldBeDisplayed() && this.gameTypes.length > 1;
        }
        return super._shouldBeDisplayed();
    }

    protected _getGameTypes(): number[] {
        if (!this.services.games.recentlyPlayedGames.gameTypes) {
            return [];
        }

        let gameTypes = this.services.games.recentlyPlayedGames.gameTypes;
        return this._applyGameGroupFiltering(gameTypes);
    }

    _renderList(listPosition: number): React.ReactElement | null {
        return (<RecentlyPlayedComponent key={this.listKey} viewModel={this} listPosition={listPosition} />);
    }
}